module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Выбрать режим отображения","table":"Только таблица","map":"Только карта","table-chart":"Таблица + График","table-map":"Таблица + Карта","table-map-chart":"Таблица + Карта + График"},"en":{"title":"Select workspace type","table":"Table only","map":"Map only","table-chart":"Table + Chart","table-map":"Table + Map","table-map-chart":"Table + Map + Chart"}}')
  delete Component.options._Ctor
}
